module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item; 
    ; __append("\n\n<div name=\"form-content\" class=\"wh100 content\">\n    ")
    ; __append( UI.Template.render(widget.itemTemplate, locals) )
    ; __append("\n    ")
    ;  if (widget.canSave()) { 
    ; __append("\n    <div class=\"flex padding__medium\">\n        <div class=\"flex-double-item form__buttons\">\n            <div name=\"edit\" title=\"Редактировать\" on-click=\"onEditClick\">\n                <div class=\"icon-20 icon-mode_edit gl-pointer button\"></div>\n            </div>\n        </div>\n\n        <div class=\"flex-item form__buttons text-right\" name=\"editor-buttons\" style=\"display: none\">\n            <div name=\"save\" title=\"Сохранить\" on-click=\"onSaveClick\">\n                <div class=\"icon-20 icon-check gl-pointer button\"></div>\n            </div>\n            <div name=\"cancel\" title=\"Отмена\" on-click=\"onCancelClick\">\n                <div class=\"icon-20 icon-close gl-pointer button\"></div>\n            </div>\n        </div>\n    </div>\n    ")
    ;  } 
    ; __append("\n</div>\n")
  }
  return __output.join("");

}